<div class="lp-header">
  <swiper-container
    class="full-width"
    pagination="true"
    pagination-type="progressbar"
    navigation="true"
    autoplay="true"
    autoplay-delay="10000"
    autoplay-disable-on-interaction="false"
    (swiperinit)="onSwiper($event)"
    a11y="true"
    >
    @for (h of headers | async; track h; let i = $index) {
      <swiper-slide>
        <div class="lp-header-slide" [ngStyle]="h.bgStyle">
          <div class="text">
            <h1 [innerHTML]="h.title"></h1>
            @if (h.description) {
              <div [innerHTML]="h.description"></div>
            }
            <a [href]="h.link">
              click here to learn more
              <i class="fas fa-arrow-right"></i>
            </a>
            <app-searchbar
              (click)="searchFocused()"
              (keyup)="searchFocused()"
              (focusout)="searchFocused()"
            ></app-searchbar>
          </div>
        </div>
      </swiper-slide>
    }
  </swiper-container>
</div>
